var event = {

    init: function () {
        $(document).on('click', '[data-event-calendar]', event.toggleCalendar);
    },

    toggleCalendar: function () {
        var event_id = $(this).attr('data-event-calendar');

        ajax({
            url: route.event.toggle_calendar,
            type: 'post',
            data: {
                event_id: event_id
            }
        }, function (json) {
            if (typeof json === 'object' && json != null) {
                if (json.success) {
                    event.btnText(event_id, (json.type == 'create' ? true : false));

                    if (json.type == 'create') {
                        $('[data-event-calendar="' + event_id + '"]').trigger('eventCreate');
                    } else {
                        $('[data-event-calendar="' + event_id + '"]').trigger('eventDelete');
                    }
                } else if (json.error) {
                    if (user.id) {
                        modalNotify.create({
                            text: json.error,
                            btn: 'Закрыть',
                            onClickClose: true
                        });
                    } else {
                        $('body').append('<a target="_blank" href="' + route.login + '" style="display:none"></a>');
                        $('[href="' + route.login + '"]')[0].click();
                    }
                }

                event.buttonsCreate(event_id);
            } else {
                modalNotify.create({
                    text: 'Что-то пошло не так, поробуйте позже :(',
                    btn: 'Закрыть',
                    onClickClose: true
                });
            }
        });
    },

    btnText: function (event_id, active, html) {
        html = html && html.length ? html : $('body');

        $('[data-event-calendar="' + event_id + '"]', html).each(function () {
            var text = $(this).attr('data-event-btn-text'), btn = $(this);

            if (text) {
                var text_arr = text.split('|');

                if (active) {
                    btn.html(text_arr[1]);
                } else {
                    btn.html(text_arr[0]);
                }
            }

            if (active) {
                btn.addClass('active');
            } else {
                btn.removeClass('active');
            }

            if (btn.hasClass('favebook-icon')) {
                if (active) {
                    btn.html('<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check"><polyline points="20 6 9 17 4 12"></polyline></svg>');
                    btn.addClass('pulse-text');
                    setTimeout(() => {
                        btn.removeClass('pulse-text')
                    }, 750);
                } else {
                    btn.removeClass('pulse-text')
                    btn.addClass('pulse-text-off')
                    btn.html('<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-plus"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>');
                    setTimeout(() => {
                        btn.removeClass('pulse-text-off')
                    }, 750);
                }
            }
        });
    },

    buttonsCreate: function (event_id) {
        $('[data-event-calendar="' + event_id + '"]').each(function () {
            if (!$(this).hasClass('favebook-icon')) {
                $(this).after($(this).clone()).remove();
            }
        });
    }

}

$(event.init);

export default event;